import http from '../../../services/http-common';

class ReceivableAccountsService {
getReceivableAccountsForList(id) {
    return http.get(`/ReceivableAccounts/list/${id}`);
    }
generateCode(id) {
    return http.get(`/ReceivableAccounts/generateCode/${id}`);
    }



getReceivableAccountsIDforFirst(id) {
    return http.get(`/ReceivableAccounts/first/ReceivableAccountsID/${id}`);
}
getReceivableAccountsIDOtherEntry(id) {
    return http.get(`/ReceivableAccounts/otherEntry/ReceivableAccountsID/${id}`);
}
insert(data) {
    return http.post(`/ReceivableAccounts/add`,data);
}
update(data) {
    return http.put(`/ReceivableAccounts/edit`,data);
}
}

export default new ReceivableAccountsService();